<template>

    <div v-if="project" class="assign-to-user-modal-component-container">

        <div class="project-name">
            {{ project.name }}
        </div>

        <div class="project-tracks-count text-stardust-grey">
            {{ project.trackcount }} Tracks.
        </div>
        <div class="users-select-container">

            <select-typeahead v-model="selecteduser" model="user" v-bind:multiple="false" modelField="email"
                              placeholder="Select a User" v-bind:min-length="0"></select-typeahead>

        </div>

        <div class="clearfix"></div>

        <a class="btn btn-raised btn-danger btn-xl font-weight-semibold mt-4" href="#" v-on:click="assignProjectToUser">
            Assign
        </a>

    </div>

</template>

<script>

    import Vue from 'vue';
    import {playerService} from '../player-service';
    import SelectTypeaheadComponent from '../components/select-typeahead';
    import ToastrType from '../toastr-types.interface';

    export default Vue.component(
        'assign-to-user',
        {

            data: function () {

                return {
                    project: null,
                    selecteduser: ''
                };

            },

            mounted: function () {

                // Configure all outgoing Ajax requests
                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    cache: false
                });

                // Change the edit project contents depending on whats passed to it.
                playerService.$on(
                    'assign-to-user',
                    (project) => {
                        // Update curr track for modal.
                        this.project = project;

                        // Open the modal.
                        window.webpackOpenBsModalWorkaround('#assignToUser');

                    }
                );
            },

            methods: {
                assignProjectToUser: function () {

                    let ctx = this;

                    $.ajax({
                        method: 'POST',
                        url: '/api/projects/'+ ctx.project.id + '/assign-to-user',
                        data: {
                            user: ctx.selecteduser
                        },
                        cache: false
                    })
                        .done(function (response) {
                            playerService.toast(response.message, ToastrType.Success);

                            window.webpackCloseBsModalWorkaround('#assignToUser');
                        })
                        .fail(function (responseData) {
                            playerService.toast(responseData.responseJSON.message, ToastrType.Error);
                        });
                }
            },

            components: {
                'select-typeahead': SelectTypeaheadComponent
            }
        }
    );

</script>
